import { getDataGridDynamicHeight } from '@modules/common/utils';
import { UsersTableHeader } from '@modules/users/components/UsersTable/UsersTableHeader';
import { useUserManagementStore } from '@modules/users/store/hooks';
import {
  getUsersColumns,
  getUsersGridInitialState,
} from '@modules/users/utils';
import { Box } from '@mui/material';
import { DataGridPro } from '@mui/x-data-grid-pro';

const TABLE_HEIGHT = 400;
const ROW_HEIGHT = 38;
const HEADER_HEIGHT = 45;
const TOOLBAR_HEIGHT = 50;

export const UsersTable = () => {
  const isLoading = useUserManagementStore(
    ({ visual }) => visual.isFetchingUsers,
  );
  const rows = useUserManagementStore(({ users }) => users);
  const columns = getUsersColumns();
  const initialState = getUsersGridInitialState();

  return (
    <Box
      sx={{
        height: getDataGridDynamicHeight(
          TABLE_HEIGHT,
          rows.length,
          ROW_HEIGHT,
          HEADER_HEIGHT,
          TOOLBAR_HEIGHT,
        ),
        width: '100%',
      }}
    >
      <DataGridPro
        sx={{
          border: 'none',
          '& .MuiDataGrid-row': {
            position: 'relative',
            '&: hover, &.Mui-selected': {
              '.js-row-actions-menu': {
                opacity: 1,
              },
            },
          },
        }}
        initialState={initialState}
        loading={isLoading}
        rows={rows}
        columns={columns}
        rowHeight={ROW_HEIGHT}
        columnHeaderHeight={HEADER_HEIGHT}
        hideFooter
        disableColumnMenu
        getRowId={({ id }) => id}
        slots={{
          toolbar: () => <UsersTableHeader />,
        }}
      />
    </Box>
  );
};
